// Others
import axiosClient from './axiosClient';
import { urlApiPO, urlApiVendor } from '~/utils/constants/apis';
import { IQueryParamBase } from '~/utils/interface/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IFormPO, IPayloadEditPO, IPO, IRequestPOList } from '~/utils/interface/po';
import { IVendor, IVendorPONumber } from '~/utils/interface/vendor';

const poApi = {
  getPOList: (params: IRequestPOList) => {
    const url = urlApiPO.getPOList;
    return axiosClient.get<IBaseResponse<IListDataResponse<IPO[]>>>(url, { params });
  },

  deletePO: (podId: string) => {
    const url = urlApiPO.deletePO(podId);
    return axiosClient.delete<IBaseResponse>(url);
  },

  getVendorsList: (params: IQueryParamBase) => {
    const url = urlApiVendor.getVendorList;
    return axiosClient.get<IBaseResponse<IListDataResponse<IVendor[]>>>(url, { params });
  },

  getPONumber: (timeZone: string) => {
    const url = urlApiPO.getPONumber;
    return axiosClient.get<IBaseResponse<IVendorPONumber>>(url, {
      params: {
        timeZone,
      },
    });
  },

  createPO: (body: IFormPO) => {
    const url = urlApiPO.createPO;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  editPO: (payload: IPayloadEditPO) => {
    const { body, poId } = payload;
    const url = urlApiPO.editPO(poId);
    return axiosClient.put<IBaseResponse>(url, body);
  },
};

export default poApi;
